var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 19,
    viewBox: "0 0 4 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.2195C2.55228 10.2195 3 9.76421 3 9.20259C3 8.64097 2.55228 8.18569 2 8.18569C1.44772 8.18569 1 8.64097 1 9.20259C1 9.76421 1.44772 10.2195 2 10.2195Z",
    stroke: "#232732",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.10119C2.55228 3.10119 3 2.6459 3 2.08428C3 1.52267 2.55228 1.06738 2 1.06738C1.44772 1.06738 1 1.52267 1 2.08428C1 2.6459 1.44772 3.10119 2 3.10119Z",
    stroke: "#232732",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.3378C2.55228 17.3378 3 16.8825 3 16.3209C3 15.7593 2.55228 15.304 2 15.304C1.44772 15.304 1 15.7593 1 16.3209C1 16.8825 1.44772 17.3378 2 17.3378Z",
    stroke: "#232732",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.bc7ad48e02d1a08152d24a097712b221.svg";
export { ForwardRef as ReactComponent };